module.exports = __webpack_public_path__ + "static/media/Properties.0b08281d.png";